import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CircuitInterface } from 'app/models/circuit.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { CircuitDataTransformPost } from './data-transforms/circuit.data.transform.post';
import { CircuitDataTransformGet } from './data-transforms/circuit.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class CircuitHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/circuits(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformDown: CircuitDataTransformPost,
    private readonly _transformUp: CircuitDataTransformGet,
  ) {}

  intercept(req: HttpRequest<CircuitInterface>, next: HttpHandler): Observable<HttpEvent<CircuitInterface>> {
    return RequestService.getTransformedHttpEvent<CircuitInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
